'use strict';

module.exports = require('./matrix');
module.exports.Decompositions = module.exports.DC = require('./decompositions');



/*****************
 ** WEBPACK FOOTER
 ** ./~/curve-fitting/~/ml-matrix/src/index.js
 ** module id = 9
 ** module chunks = 0
 **/